import React, { useState } from 'react';
import { connect } from 'react-redux';
import '../../assets/css/servermanagement.css';
import { useEffect } from 'react';
import { ChevronLeft, Payment, PlaceRounded, PlayArrow, ShowChart, Work } from '@material-ui/icons';
import FormEdit from './EditTagsForm/FormEdit';
// import Schedule from './EditSchedule/Schedule';
import ApiConnect from '../common/ApiConnect';
import DisplayNumbers from '../admin/Metrics/subcomponent/DisplayNumbers';
import { Footer } from '../common/Footer';

const ServerManagement = ({
  isloading
}) => {
  //redux state
  const [activeTab, setActiveTab] = useState('Container');
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [itemData, setItemData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [showSched, setShowSched] = useState(false);
  const [serverList, setServerList] = useState([]);
  const [tempList, setTempList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    caas_orderItemUid: '',
    caas_clientName: '',
    caas_environment: '',
    caas_region: '',
    caas_state: '',
    caas_camEnv: '',
    caas_vendorName: ''
  });

  const toggleRow = (id) => {
    const newExpanded = new Set(expandedRows);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedRows(newExpanded);
  };

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
  };

  const resetFilters = () => {
    setFilters({
      // privateDNSName: '',
      // orderid: '',
      // clientname: '',
      // environment: '',
      // regionAlias: '',
      // instanceState: '',
      // platformtype: 'dedicated',
      // InstanceType: '',
      // accountType: '',
      // assetname: ''
    });

    const fields = document.querySelectorAll('.filter-input');
    fields.forEach((item) => {
      item.value = '';
    })
  };

  const getStatusBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'running':
        return 'badge-running';
      case 'terminated':
      case 'terminating':
        return 'badge-terminated';
      case 'stopped':
      case 'stopping':
        return 'badge-stopped';
      default:
        return '';
    }
  };

  const setFormData = (item) => {
    setShowForm(true);
    let alterData = { ...item };
    const [year, month, day] = item['caas_sed'].split('T')[0].split('-');
    alterData.caas_sed = `${year}-${month}-${day}`;
    //change the environment data to to lowercase
    alterData.caas_environment = item['caas_environment'].toLowerCase();
    setItemData(alterData);
  }

  const tableButton = (evt) => {
    evt.stopPropagation();
    const curdiv = evt.target.closest("td").querySelector(".table-menu");
    if (curdiv.style.display === "block") {
      curdiv.style.display = "none";
    } else {
      const alldiv = document.getElementsByClassName("table-menu");
      for (let i = 0; i < alldiv.length; i++) alldiv[i].style.display = "none";
      curdiv.style.display = "block";
    }
  };

  //fetch the data on api gateway
  const fetchData = () => {
    ApiConnect.get(
      'fui/orders/genwizard4'
    ).then(resp => {
      setTempList(resp.data);
    }).catch(err => {
      setIsLoading(false);
      console.log(err);
    })
  }

  // useEffect(() => {
  //   if (activeTab === 'dedicated')
  //     setFilters({ ...filters, platformtype: activeTab, InstanceType: '' });
  //   else
  //     setFilters({ ...filters, platformtype: '', InstanceType: 'Container' });

  //   fetchData();
  // }, [activeTab]);

  useEffect(() => {
    setTimeout(() => {
      fetchData();
    }, 5000);
  }, [])

  useEffect(() => {
    const servers = tempList.filter(item =>
      Object.entries(filters).every(([key, value]) => {
        if (!value) return true;

        if (typeof item[key] === "string") {
          if (key !== 'caas_camEnv')
            return item[key].toLowerCase().includes(value.toLowerCase());
          return item[key].toLowerCase() === value.toLowerCase()
        }

        return item[key] === value;
      })
    );
    setServerList(servers);
    setTimeout(() => {
      setIsLoading(false);
    }, 10000);
  }, [tempList, filters])

  return (
    <>
      <div className="dashboard">
        <div className="background-gradient"></div>
        <div className="header">
          <div className="tabs">
            {/* <button
              className={`tab ${activeTab === 'dedicated' ? 'active' : ''}`}
              onClick={() => setActiveTab('dedicated')}
            >
              DEDICATED
            </button> */}
            <button
              className={`tab ${activeTab === 'Container' ? 'active' : ''}`}
              onClick={() => setActiveTab('Container')}
            >
              CONTAINER
            </button>
            <div className="filter-actions">
              <button className="btn btn-secondary" onClick={() => {
                resetFilters();
              }}>
                Reset Filter
              </button>
              <button className="btn btn-primary" onClick={() => {
                fetchData();
                setIsLoading(true);
              }}>
                Refresh Data
              </button>
            </div>
          </div>
        </div>
        {/* <div className="box01" style={{ border: 'none', boxShadow: 'none', width: '100%', height: '100px', margin: '0px 0 20px 0' }}>
          <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0' }}>
            <div style={{ display: 'flex', width: '32%', height: '90%', padding: '10px 10px', margin: '0 20px 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Work style={{ float: 'left', width: '25px', height: '25px', padding: '10px', borderRadius: '10px', backgroundColor: 'rgba(79, 36, 154, 0.13)', color: '#7C3AED', border: '1px solid #EBEBEB' }} />
              </div>
              <div style={{ display: 'block' }}>
                <span className='title-task' style={{ fontSize: '2.8rem', margin: '10xp 10px 0 10px' }}>15</span>
                <span className='title-task' style={{ width: '100%', fontSize: '.9rem', margin: '0 15px' }}>Server Count</span>
              </div>
            </div>
            <div style={{ display: 'flex', width: '32%', height: '90%', padding: '10px 10px', margin: '0 20px 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ShowChart style={{ float: 'left', width: '25px', height: '25px', padding: '10px', borderRadius: '10px', backgroundColor: 'rgba(79, 36, 154, 0.13)', color: '#7C3AED', border: '1px solid #EBEBEB' }} />
              </div>
              <div style={{ display: 'block' }}>
                <span className='title-task' style={{ fontSize: '2.8rem', margin: '10xp 10px 0 10px' }}>10</span>
                <span className='title-task' style={{ width: '100%', fontSize: '.9rem', margin: '0 15px' }}>Server Running</span>
              </div>
            </div>
            <div style={{ display: 'flex', width: '32%', height: '90%', padding: '10px 10px', margin: '0 20px 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PlaceRounded style={{ float: 'left', width: '25px', height: '25px', padding: '10px', borderRadius: '10px', backgroundColor: 'rgba(79, 36, 154, 0.13)', color: '#7C3AED', border: '1px solid #EBEBEB' }} />
              </div>
              <div style={{ display: 'block' }}>
                <span className='title-task' style={{ fontSize: '2.8rem', margin: '10xp 10px 0 10px' }}>12</span>
                <span className='title-task' style={{ width: '100%', fontSize: '.9rem', margin: '0 15px' }}>Server Region</span>
              </div>
            </div>
            <div style={{ display: 'flex', width: '32%', height: '90%', padding: '10px 10px', margin: '0 0 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Payment style={{ float: 'left', width: '25px', height: '25px', padding: '10px', borderRadius: '10px', backgroundColor: 'rgba(79, 36, 154, 0.13)', color: '#7C3AED', border: '1px solid #EBEBEB' }} />
              </div>
              <div style={{ display: 'block' }}>
                <span className='title-task' style={{ fontSize: '2.8rem', margin: '10xp 10px 0 10px' }}>2</span>
                <span className='title-task' style={{ width: '100%', fontSize: '.9rem', margin: '0 15px' }}>Server Type</span>
              </div>
            </div>
          </div>
        </div> */}
        <div className="filter-section">
          <div className="filter-grid">
            {activeTab === 'dedicated' && (
              <div className="filter-item">
                <input
                  type="text"
                  className="filter-input"
                  placeholder="Filter by Private DNS..."
                  value={filters.privateDns}
                  disabled={isloading}
                  onChange={(e) => handleFilterChange('privateDNSName', e.target.value)}
                />
              </div>
            )}
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Product Name..."
                value={filters.caas_productName}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_productName', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Order ID..."
                value={filters.caas_orderItemUid}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_orderItemUid', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Client Name..."
                value={filters.caas_clientName}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_clientName', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <select
                className="filter-input"
                value={filters.caas_vendorName}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_vendorName', e.target.value)}
              >
                <option value="">All Vendors</option>
                <option value="CAM">CAM</option>
                <option value="Marketplace">Market Place</option>
              </select>
            </div>
            <div className="filter-item">
              <select
                className="filter-input"
                value={filters.caas_environment}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_environment', e.target.value)}
              >
                <option value="">All Environments</option>
                <option value="prod">Production</option>
                <option value="test">Test</option>
                <option value="dev">Development</option>
              </select>
            </div>
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Region..."
                value={filters.caas_region}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_region', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <select
                className="filter-input"
                value={filters.caas_state}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_state', e.target.value)}
              >
                <option value="">All Status</option>
                <option value="running">Running</option>
                <option value="stopped">Stopped</option>
                <option value="terminated">Terminated</option>
                <option value="terminating">Terminating</option>
              </select>
            </div>
          </div>
        </div>

        <div className="table-container">
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  {activeTab === 'dedicated' &&
                    (<th>Private DNS</th>)
                  }
                  <th>Product Name</th>
                  <th>Order ID</th>
                  <th>Client Name</th>
                  <th>Vendor Name</th>
                  <th>Environment</th>
                  <th>Region</th>
                  <th>Service End Date</th>
                  <th>Status</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ?
                  <React.Fragment>
                    {Array.from({ length: activeTab === 'dedicated' ? 10 : 9 }).map((_, j) => (
                      <tr className='skeleton'>
                        {Array.from({ length: activeTab === 'dedicated' ? 9 : 8 }).map((_, j) => (
                          <td><span>*******************</span></td>
                        ))}
                        <td style={{ height: '30px' }}><span>*****</span></td>
                      </tr>
                    ))}
                  </React.Fragment>
                  : serverList.length > 0 ?
                    <>
                      {serverList.map((server) => (
                        <>
                          <tr
                            className={expandedRows.has(server.caas_id) ? 'expanded' : ''}
                            onClick={() => toggleRow(server.caas_id)}
                          >
                            {activeTab === 'dedicated' &&
                              (<td><span className="private-dns">{server.privateDNSName}</span></td>)
                            }
                            <td>{server.caas_productName}</td>
                            <td>{server.caas_orderItemUid}</td>
                            <td><span className="client-name">{server.caas_clientName}</span></td>
                            <td><span className="badge badge-env">{server.caas_vendorName}</span></td>
                            <td><span className="badge badge-env">{server.caas_environment}</span></td>
                            <td>{server.caas_region}</td>
                            <td>{server.caas_sed}</td>
                            <td>
                              <span className={`badge ${getStatusBadgeClass(server.caas_state)}`}>
                                {server.caas_state}
                              </span>
                            </td>
                            <td>
                              <button className="action-btn"><ChevronLeft style={{ transform: !expandedRows.has(server.caas_id) ? 'rotate(-90deg)' : 'rotate(90deg)' }} /></button>
                            </td>
                          </tr>
                          <tr className={`details-row ${!expandedRows.has(server.caas_id) ? 'hidden' : ''}`}>
                            <td colSpan="10">
                              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ width: '98%', display: 'flex' }}>
                                  <div style={{ width: '100%', border: '1px solid #BEBEBE', display: 'flex-inline', padding: '20px', textAlign: 'left', borderRadius: '8px 8px', backgroundColor: '#FFFFFF' }}>
                                    <table className='innerserverdetails'>
                                      <tbody>
                                        <tr>
                                          <td>Access Link URL:</td>
                                          <td>
                                            {
                                              server.caas_alinkURL != "" ?
                                                <>
                                                  {
                                                    server.caas_alinkURL.split(",").map(item => { 
                                                    const subd = item.indexOf('cui-') >= 0 ? "/chatbot" : item.indexOf('iam-') >= 0? "/iam" : "";
                                                        
                                                    return (
                                                      <>
                                                        <a  className='accessLink' href={'https://' + item + subd} target='_blank'>https://{item + subd}</a>
                                                        <br/>
                                                      </>
                                                    )})
                                                  }
                                                </>
                                                :
                                                <>
                                                  Not Available
                                                </>
                                            }</td>
                                          <td>Domain Context Root:</td>
                                          <td></td>
                                        </tr>
                                        {/* <tr>
                                        <td>Instance ID:</td>
                                        <td>{server.instanceId}</td>
                                        <td>Instance State:</td>
                                        <td>{server.instanceState}</td>
                                      </tr> */}
                                        <tr>
                                          <td>Product UID:</td>
                                          <td>{server.caas_productUId}</td>
                                          <td>App Core:</td>
                                          <td>{server.caas_appcore}</td>
                                        </tr>
                                        <tr>
                                          <td>Cluster ID:</td>
                                          <td>{server.caas_dcr}</td>
                                          <td>App Agent:</td>
                                          <td>{server.caas_appagent}</td>
                                        </tr>
                                        <tr>
                                          <td>Customer Enterprise ID:</td>
                                          <td>{server.caas_customerEID}</td>
                                          <td>Secondary POC:</td>
                                          <td>{server.caas_secondaryPOC}</td>
                                        </tr>
                                        <tr>
                                          <td>Project Name:</td>
                                          <td>{server.caas_projectName}</td>
                                          <td>WBSE Code:</td>
                                          <td>{server.caas_wbsecode}</td>
                                        </tr>
                                        <tr>
                                          <td>Notes:</td>
                                          <td>{server.caas_notes}</td>
                                          <td>Date Started:</td>
                                          <td>{server.caas_dateInsert}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr className={`details-row ${!expandedRows.has(server.caas_id) ? 'hidden' : ''}`} style={{ border: 'none' }}>
                            <td colSpan="10" style={{ textAlign: 'right' }}>
                              <div style={{ marginRight: '18px', position: 'relative' }}>
                                {/* {activeTab === 'dedicated' &&
                                <button type="button" className='buttonActions' onClick={() => setShowSched(true)}>Schedule</button>
                              } */}
                                <button type="button" className='buttonActions focus' onClick={() => setFormData(server)}>Edit Tags</button>
                                <button type="button" className='buttonActions' onClick={(e) => tableButton(e)} disabled={true}>Actions</button>
                                <div className="table-menu" style={{ display: "none", right: '-10px', top: '45px' }}>
                                  <div className="tri" style={{ right: '50px', top: '-8px' }}></div>
                                  <ul>
                                    {/* <li onClick={() => { }}>Connect</li> */}
                                    <li onClick={() => { }}>Start</li>
                                    <li onClick={() => { }}>Stop</li>
                                    <li onClick={() => { }}>Terminate</li>
                                  </ul>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </>
                      ))}
                    </> :
                    <tr>
                      <td colSpan="10">
                        <div style={{ height: '260px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <div style={{ textAlign: 'center' }}>
                            <h2 style={{ fontSize: '1.8rem', color: '#333333', fontWeight: '600' }}>No data found</h2>
                            <span>Try to click button the Refresh Data</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        <Footer />
      </div>
      <FormEdit show={showForm} title={"Edit Tags"} width={'550px'} setShow={setShowForm} saveDisabled={true}>
        <div>
          <form id='editTags' className='formDataEdit'>
            <div className='formInputs'>
              <label>Customer Enterprise ID:</label>
              <input type="text" name="customerEnterpriseId" value={itemData.caas_customerEID} />
            </div>
            <div className='formInputs'>
              <label>Secondary POC:</label>
              <input type="text" name="secondaryPOC" value={itemData.caas_secondaryPOC} />
            </div>
            <div className='formInputs'>
              <label>Environment:</label>
              <select type="text" name="environment" value={itemData.caas_environment}>
                <option value="production">Production</option>
                <option value="dev">Dev</option>
                <option value="uat">Uat</option>
                <option value="sales">Sales</option>
                <option value="test">Test</option>
              </select>
            </div>
            <div className='formInputs'>
              <label>Initiative:</label>
              <select type="text" name="initiatives" value={itemData.caas_intiative}>
                <option value="Agile Capability">Agile Capability</option>
                <option value="Change Enablement">Change Enablement</option>
                <option value="FORM, Methods & Estimators">FORM, Methods & Estimators</option>
                <option value="Language Translation Services">Language Translation Services</option>
                <option value="Living Systems Advisory">Living Systems Advisory</option>
                <option value="1AAA">1AAA</option>
                <option value="DevOps Capability">DevOps Capability</option>
                <option value="ICS">ICS</option>
                <option value="IEMP">IEMP</option>
                <option value="myDiagnostic">myDiagnostic</option>
                <option value="myIndustry">myIndustry</option>
                <option value="myMDI">myMDI</option>
                <option value="myNav">myNav</option>
                <option value="mySP">mySP</option>
                <option value="myWizard Apps">myWizard - Other Apps</option>
                <option value="myWizard AI Apps">myWizard AI Apps</option>
                <option value="myWizard_AiOps">Mywizard AiOps</option>
                <option value="myWizard Governance">Mywizard Governance</option>
                <option value="myWizard Platform Mgt">Mywizard Platform Mgt</option>
                <option value="myWizard SaaS">myWizard SaaS</option>
                <option value="myWizard SI">myWizard SI</option>
                <option value="Technical architecture">Technical architecture</option>
                <option value="Transformation Office">Transformation Office</option>
                <option value="UX">UX</option>
                <option value="Automation Deployment">Automation Deployment</option>
                <option value="Sales & Solutions">Automation Sales & Solution</option>
                <option value="PMO">PMO</option>
              </select>
            </div>
            <div className='formInputs'>
              <label>WBSE Code:</label>
              <input type="text" name="wbseCode" value={itemData.caas_wbsecode} />
            </div>
            <div className='formInputs'>
              <label>Service End Date:</label>
              <input type="date" name="serviceEndDate" value={itemData.caas_sed} />
            </div>
            <div className='formInputs'>
              <label>Project Name:</label>
              <input type="text" name="projectName" value={itemData.caas_projectName} />
            </div>
            <div className='formInputs' style={{ height: '80px' }}>
              <label>Notes:</label>
              <textarea type="text" name="notes">{itemData.caas_notes}</textarea>
            </div>
          </form>
        </div>
      </FormEdit>
      {/* <Schedule show={showSched} setShow={setShowSched} /> */}
    </>
  );
};

const reduxStatesData = (state) => ({
  serverList: state.servers.instancesNewTags,
  isloading: state.servers.isLoading
});

export default connect(reduxStatesData)(ServerManagement);